import { notification } from 'antd';

import apiNetCore from '../services/apiNetCore';

export const carregaEstadosBrasil = async (
  setEstados,
  setCarregandoEstados
) => {
  setEstados([]);
  try {
    setCarregandoEstados(true);
    const response = await apiNetCore.get('/EstadoAts/Consultar?idPais=30');
    setEstados(response.data.data);
  } catch (err) {
    notification.error({
      message: 'Ops, não conseguimos buscar os estados',
      description: 'Se o problema persistir, entre em contato com o suporte',
    });
  } finally {
    setCarregandoEstados(false);
  }
};
